import { Tag } from 'antd';
import { BadgeProps } from 'antd/es/badge';
import clsx from 'classnames';
import { FC } from 'react';

import {
  NotificationSeverityColor,
  NotificationSeverityLabel,
} from '../../constants/NotificationSeverity';
import { MemoSeverity } from '../../graphql.generated';

import styles from './styles.module.less';

type NotificationSeverityProps = Omit<BadgeProps, 'status' | 'text'> & {
  severity: MemoSeverity;
};

const NotificationSeverity: FC<NotificationSeverityProps> = ({
  className,
  severity,
  ...rest
}) => (
  <Tag
    {...rest}
    className={clsx(styles.tag, className)}
    color={NotificationSeverityColor[severity]}
  >
    {NotificationSeverityLabel[severity]}
  </Tag>
);

NotificationSeverity.displayName = 'NotificationSeverity';

export default NotificationSeverity;
